<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <header3
    v-if="title"
    :text="title"
    classes="mb-3 md:col-span-8 lg:col-span-6 text-base"
    :is-umbraco="isUmbraco"
    :theme="theme"
  />
  <Paragraph
    v-if="description && !isRichtext"
    :text="description"
    :isUmbraco="isUmbraco"
    :theme="theme"
    :isManchet="false"
    classes="md:col-span-6 "
  />
  <RichText
    v-if="description && isRichtext"
    :text="description"
    :isUmbraco="isUmbraco"
    :theme="theme"
    classes="md:col-span-6 "
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { getThemeType } from "@/util/helper";
import Header3 from "@/components/Typography/Header3.ce.vue";
import RichText from "@/components/Typography/RichText.ce.vue";
import Paragraph from "@/components/Typography/Paragraph.ce.vue";
import { Idescription } from "@/types/types";

export interface projectSpecificationProps {
  title: string;
  description: string | Idescription;
  isUmbraco?: boolean;
  theme: "dark" | "light";
  isRichtext: boolean;
}

const props = withDefaults(defineProps<projectSpecificationProps>(), {
  isUmbraco: false,
  isRichtext: false,
});

const themeType = computed(() => {
  if (!theme.value) return "dark";
  return getThemeType(theme.value);
});
</script>
```
